export const DEFAULT_INVITATION_CONTENT =
  '<p>*|salutation|*</p>\n\n\n\n<p>*|groupname|*</p>';

export type InvitationTemplatePreviewOptions = {
  content: string;
  signature?: string;
  senderName?: string;
  salutationPreview?: string;
  personalMessage?: string;
  investorName?: string;
  username?: string;
};

/**
 * Substitutes invitation merge variables with preview/sample values for display or test emails.
 */
export function buildInvitationPreviewHtml(
  options: InvitationTemplatePreviewOptions,
): string {
  const {
    content,
    signature = '',
    senderName = '',
    salutationPreview = 'Hi ______,',
    personalMessage = '',
    investorName = "Client's Name",
    username = 'client_username',
  } = options;

  const base = content.trim() ? content : DEFAULT_INVITATION_CONTENT;

  return base
    .replace(/\*\|signature\|\*/g, signature)
    .replace(/\*\|salutation\|\*/g, salutationPreview)
    .replace(/\*\|personalMessage\|\*/g, personalMessage)
    .replace(/\*\|groupname\|\*/g, senderName)
    .replace(/\*\|investorname\|\*/g, investorName)
    .replace(/\*\|username\|\*/g, username);
}
